import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '@/common/locales/en.json';
import fr from '@/common/locales/fr.json';
import { Storage } from '@/common/utils/index';

const DEFAULT_LANGUAGE = 'en';
const SUPPORTED_LANGUAGES = ['en', 'fr'];

const getStoredLanguage = () => {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
  const stored = Storage.get('language');
  return SUPPORTED_LANGUAGES.includes(stored) ? stored : DEFAULT_LANGUAGE;
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    lng: getStoredLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  if (typeof window === 'undefined') return;
  if (!SUPPORTED_LANGUAGES.includes(lng)) return;
  Storage.set('language', lng);
});

export default i18n;
